module.exports = __webpack_public_path__ + "static/media/018ce4bb.jpg";